import { __export } from './chunk-T36PI2YV.mjs';

// src/helpers/settings/printerModal.ts
var printerModal_exports = {};
__export(printerModal_exports, {
  PRINTERS_MAKE: () => PRINTERS_MAKE,
  PRINTERS_MODEL: () => PRINTERS_MODEL,
  paperWidthByModel: () => paperWidthByModel,
  paperWidthValueToLabel: () => paperWidthValueToLabel,
  printerMakeLabelToValue: () => printerMakeLabelToValue,
  printerMakeValueToLabel: () => printerMakeValueToLabel,
  printerModelLabelToValue: () => printerModelLabelToValue,
  printerModelOptionsByMake: () => printerModelOptionsByMake,
  printerModelValueToLabel: () => printerModelValueToLabel,
  printerTypeToValue: () => printerTypeToValue,
  printersMakeOptions: () => printersMakeOptions,
  valueToPrinterType: () => valueToPrinterType
});
var PRINTERS_MAKE = /* @__PURE__ */ ((PRINTERS_MAKE2) => {
  PRINTERS_MAKE2["EPSON"] = "Epson";
  PRINTERS_MAKE2["STAR"] = "Star";
  return PRINTERS_MAKE2;
})(PRINTERS_MAKE || {});
var PRINTERS_MODEL = /* @__PURE__ */ ((PRINTERS_MODEL2) => {
  PRINTERS_MODEL2["EPSON_TM_M30"] = "TM-M30";
  PRINTERS_MODEL2["EPSON_TM_U220"] = "TM-U220";
  return PRINTERS_MODEL2;
})(PRINTERS_MODEL || {});
var printersMakeOptions = [
  [
    {
      label: "Epson" /* EPSON */,
      value: 1
    }
  ]
];
var printerModelOptionsByMake = {
  1: [
    { label: "TM-U220" /* EPSON_TM_U220 */, description: "Impact", value: 1 },
    { label: "TM-M30" /* EPSON_TM_M30 */, description: "Thermal", value: 2 }
  ]
};
var paperWidthByModel = {
  ["TM-U220" /* EPSON_TM_U220 */]: [76],
  ["TM-M30" /* EPSON_TM_M30 */]: [
    // 58,
    80
  ]
};
var paperWidthValueToLabel = {
  // 58: '2.25"',
  // eslint-disable-next-line quotes
  76: "3''",
  // eslint-disable-next-line quotes
  80: "3.125''"
};
var printerModelValueToLabel = {
  1: "TM-U220" /* EPSON_TM_U220 */,
  2: "TM-M30" /* EPSON_TM_M30 */
};
var printerModelLabelToValue = {
  ["TM-U220" /* EPSON_TM_U220 */]: 1,
  ["TM-M30" /* EPSON_TM_M30 */]: 2
};
var printerMakeValueToLabel = {
  1: "Epson" /* EPSON */,
  2: "Star" /* STAR */
};
var printerMakeLabelToValue = {
  ["Epson" /* EPSON */]: 1,
  ["Star" /* STAR */]: 2
};
var printerTypeToValue = {
  ["kitchen" /* KITCHEN */]: 1,
  ["receipt" /* RECEIPT */]: 2
};
var valueToPrinterType = {
  1: "kitchen" /* KITCHEN */,
  2: "receipt" /* RECEIPT */
};

export { PRINTERS_MAKE, PRINTERS_MODEL, paperWidthByModel, paperWidthValueToLabel, printerMakeLabelToValue, printerMakeValueToLabel, printerModal_exports, printerModelLabelToValue, printerModelOptionsByMake, printerModelValueToLabel, printerTypeToValue, printersMakeOptions, valueToPrinterType };
